import React from "react";
import { List } from "../modules/Settings/Analytes";

export function AnalytesListPage() {
  return <List />;
}
